import { render, staticRenderFns } from "./Shenhe.vue?vue&type=template&id=80608520&scoped=true"
import script from "./Shenhe.vue?vue&type=script&lang=js"
export * from "./Shenhe.vue?vue&type=script&lang=js"
import style0 from "./Shenhe.vue?vue&type=style&index=0&id=80608520&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80608520",
  null
  
)

export default component.exports